import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/header/Navbar";
import Acceuil from "./components/content/home/Acceuil";
import Copyright from "./components/footer/Copyright";
import Login from "./components/content/Login/Login";
import Pays from "./components/content/parametrage/Pays/Pays";
import Bu from "./components/content/parametrage/Bu/Bu";
import Client from "./components/content/parametrage/Client/Client";
import User from "./components/content/parametrage/user/User";
import Operation from "./components/content/parametrage/Operation/Operation";
import Cout from "./components/content/parametrage/Cout/Cout";
import Account from "./components/content/parametrage/user/Account";
import PrivateRoute from "./commons/private-route";
import SaisieAgent from "./components/content/production/SaisieAgent";
import Tarification from "./components/content/parametrage/Tarification/Tarification";
import Header from "./components/header/Header";
import Cookies from "universal-cookie";
import { useEffect, useState } from "react";
import ManagerOperation from "./components/content/parametrage/MangerOperation/ManagerOperation";
import ClientPere from "./components/content/parametrage/ClientPere/ClientPere";
import Article from "./components/content/parametrage/Article/Article";
import TauxDechange from "./components/content/parametrage/TauxEchange/TauxDechange";
import { Generer } from "./components/content/facturation/Generer";
import DateVerrouillage from "./components/content/parametrage/DateVerrouillage/DateVerrouillage";
import DateVerrouillageClotureBudget from "./components/content/parametrage/DateVerrouillageClotureBudget/DateVerrouillageClotureBudget";
import DateVerrouillageClotureReforecast from "./components/content/parametrage/DateVerrouillageClotureReforecast/DateVerrouillageClotureReforecast";
import FacturePro from "./components/content/facturation/FacturePro";
import TableauDeBordFacturation from "./components/content/facturation/TableauDeBordFacturation";
import PrevisionnelQuantite from "./components/content/previsionnel/quantite/PrevisionnelQuantite";
import ExtractionSaisie from "./components/content/extraction/saisie/ExtractionSaisie";
import RentaClient from "./components/content/extraction/rentaClient/RentaClient";
import Rentabilite from "./components/content/extraction/rentabilite/Rentabilite";
import Signature from "./components/signature/Signature";
import SetTokens from "./components/forms/SetTokens";
import SecteurActivite from "./components/content/parametrage/SecteurActivite/SecteurActivite";
import NavbarChild from "./components/header/NavbarChild";
import { MediaQueryContext } from "./utils/contextes/MediaQueryContext";
import { useMediaQuery } from "react-responsive";
import MainBudget from "./components/content/budget/MainBudget";
import ExtractionBudget from "./components/content/budget/Extract/ExtractionBudget";
import MainCommission from "./components/content/commission/MainCommission";
import ExtractionCommission from "./components/content/commission/extract/ExtractionCommission";
import ImportBudget from "./components/content/budget/Import/ImportBudget";
import "./App.css";
import MainReforecast from "./components/content/reforecast/MainReforecast";
import ExtractionReforecast from "./components/content/reforecast/Extract/ExtractionReforecast";
import ExportReforcastRealiserConsolider from "./components/content/reforecast/reforcastVsRealiserConsolider/ExportReforcastRealiserConsolider";
import ImportReforcast from "./components/content/reforecast/Import/ImportReforcast";


function App() {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 900px)' });
  const [isLogged, setIsLogged] = useState<boolean>(false);
  const cookies = new Cookies();
  let token: string = cookies.get("jwt");

  useEffect(() => {
    token = cookies.get("jwt");
  }, [isLogged]);

  return (
    <Router>
      <MediaQueryContext.Provider value={{ isDesktopOrLaptop }}>
        <Header>
          <Navbar />
          <NavbarChild />
        </Header>
        <Routes>
          {/* Private Routes */}
          <Route path="/" element={<PrivateRoute token={token} />}>
            <Route path="/acceuil" element={<Acceuil />} />
            <Route path="/pays" element={<Pays />} />
            <Route path="/business-units" element={<Bu />} />
            <Route path="/clients" element={<Client />} />
            <Route path="/operations" element={<Operation />} />
            <Route path="/operationsByClient" element={<Operation />} />
            <Route path="/couts" element={<Cout />} />
            <Route path="/account" element={<Account />} />
            <Route path="/saisie-agent" element={<SaisieAgent />} />
            <Route path="/user" element={<User />} />
            <Route path="/tarifs" element={<Tarification />} />
            <Route path="/Managers-operations" element={<ManagerOperation />} />
            <Route path="/clientspere" element={<ClientPere />} />
            <Route path="/article" element={<Article />} />
            <Route path="/taux" element={<TauxDechange />} />
            <Route path="/tableau-de-bord" element={<TableauDeBordFacturation />} />
            <Route path="/generate-facture" element={<Generer />} />
            <Route path="/date-verouillage" element={<DateVerrouillage />} />
            <Route path="/date-verouillage-cloture-budget" element={<DateVerrouillageClotureBudget />} />
            <Route path="/date-verouillage-cloture-reforecast" element={<DateVerrouillageClotureReforecast />} />
            <Route path="/facturepro" element={<FacturePro />} />
            <Route path="/rentabilite" element={<Rentabilite />} />
            <Route path="/budget-client" element={<MainBudget />} />
            <Route path="/extraction-budget" element={<ExtractionBudget />} />
            <Route path="/reforecast" element={<MainReforecast />} />
            <Route path="/extraction-saisie" element={<ExtractionSaisie />} />
            <Route path="/previsionnel-qt" element={<PrevisionnelQuantite />} />
            <Route path="/renta-client" element={<RentaClient />} />
            <Route path="/secteur-act" element={<SecteurActivite />} />
            <Route path="/commission" element={<MainCommission />} />
            <Route path="/commissioncomdrc" element={<MainCommission />} />
            <Route path="/extraction-commission" element={<ExtractionCommission />} />
            <Route path="/extraction-budget" element={<ExtractionBudget />} />
            <Route path="/extraction-reforecast" element={<ExtractionReforecast />} />
            <Route path="/extraction-consolidation-reforcast" element={<ExportReforcastRealiserConsolider />} />
            <Route path="/import-budget" element={<ImportBudget />} />
            <Route path="/import-reforcast" element={<ImportReforcast />} />
          </Route>

          {/* Public Routes */}
          <Route path="/sign-in" element={<Login setIsLogged={setIsLogged} />} />
          <Route path="/:token" element={<SetTokens setIsLogged={setIsLogged} />} />

          {/* Signature Outsourcia */}
          <Route path="/outsourcia-signature" element={<Signature />} />
        </Routes>
        <footer>
          <Copyright />
        </footer>
      </MediaQueryContext.Provider>
    </Router>
  );
}

export default App;
